function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import isString from 'lodash/isString';
import CheckCircleIcon from 'svg/check-circle.svg';
import styles from './Statement.pcss';
var _React_PureComponent;
class Statement extends (_React_PureComponent = React.PureComponent) {
    get header() {
        const { headerMessage } = this.props;
        if (isString(headerMessage)) return /*#__PURE__*/ _jsx("h2", {
            className: "text--h2",
            children: headerMessage
        });
        if (/*#__PURE__*/ React.isValidElement(headerMessage)) return headerMessage;
        return /*#__PURE__*/ _jsx("h2", {
            className: "text--h2",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
        });
    }
    get icon() {
        switch(this.props.withIcon){
            case 'success':
                {
                    return /*#__PURE__*/ _jsx(CheckCircleIcon, {
                        className: styles.box__icon
                    });
                }
            default:
                return null;
        }
    }
    renderHeader() {
        if (!this.props.headerMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("header", {
            className: styles.box__header,
            children: this.header
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "col",
            children: [
                this.renderHeader(),
                /*#__PURE__*/ _jsx("div", {
                    className: "text--paragraph",
                    children: this.props.children
                })
            ]
        });
    }
    renderImage() {
        if (!this.props.imgSrc) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx("img", {
                src: this.props.imgSrc,
                className: `${styles.box__image} mr-7`,
                alt: ""
            })
        });
    }
    render() {
        const Icon = this.props.withIcon && this.icon;
        const classNameValue = this.props.boxClassName || '';
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.wrapper, {
                [styles['wrapper--center']]: !this.props.isOnTop
            }, {
                'align-items-center': !this.props.isOnTop,
                'align-items-start': this.props.isOnTop
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: cn(classNameValue, styles.box),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row no-gutters",
                    children: [
                        Icon || this.renderImage(),
                        this.renderContent(),
                        Icon && this.renderImage()
                    ]
                })
            })
        });
    }
}
_define_property(Statement, "propTypes", {
    // Explicit props
    headerMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]),
    imgSrc: PropTypes.string,
    withIcon: PropTypes.oneOf([
        'success'
    ]),
    isOnTop: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)
    ]).isRequired,
    boxClassName: PropTypes.string
});
_define_property(Statement, "defaultProps", {
    isOnTop: false
});
export default withStyles(styles)(Statement);
